import { CodeSurfer as Surfer } from "code-surfer";
import { Appear, Background } from "gatsby-theme-mdx-deck";
import Cereal from "../../../../assets/cereal.svg";
import customTheme from "../../../../src/theme";
import * as L from "../../../../src/layout";
import FormidableIntro from "../../../../assets/formidable-intro.svg";
import GraphQLLogo from "../../../../assets/graphql-logo.svg";
import FinishedApp from "../../../../assets/finished-app.jpg";
import GraphQLRequests from "../../../../assets/graphql-requests.svg";
import GraphQLDocParsing from "../../../../assets/graphql-doc-parsing.svg";
import GraphQLDocSimple from "../../../../assets/graphql-doc-simple.svg";
import GraphQLDocVars from "../../../../assets/graphql-doc-vars.svg";
import GraphQLFieldSimple from "../../../../assets/graphql-field-simple.svg";
import GraphQLSelectionSetNode from "../../../../assets/graphql-selectionset-node.svg";
import GraphQLSelections from "../../../../assets/graphql-selections.svg";
import Operations from "../../../../assets/operations.svg";
import OperationKeys from "../../../../assets/operation-keys.svg";
import Results from "../../../../assets/results.svg";
import CombinedError from "../../../../assets/combined-error.svg";
import Signals from "../../../../assets/signals.svg";
import OperationMetadata from "../../../../assets/operation-metadata.svg";
import ClientArchitecture from "../../../../assets/client-architecture.svg";
import ClientEventHub from "../../../../assets/client-event-hub.svg";
import Exchanges from "../../../../assets/exchanges.svg";
import ExchangeStructure from "../../../../assets/exchange-structure.svg";
import ExchangeSignature from "../../../../assets/exchange-signature.svg";
import OperationFlow from "../../../../assets/operation-flow.svg";
import TeardownFlow from "../../../../assets/teardown-flow.svg";
import CacheData from "../../../../assets/cache-data.svg";
import NormalisedCacheData from "../../../../assets/normalised-cache-data.svg";
import Introspection from "../../../../assets/introspection.svg";
import DocumentCaching from "../../../../assets/document-caching.svg";
import React from 'react';
export default {
  Surfer,
  Appear,
  Background,
  Cereal,
  customTheme,
  L,
  FormidableIntro,
  GraphQLLogo,
  FinishedApp,
  GraphQLRequests,
  GraphQLDocParsing,
  GraphQLDocSimple,
  GraphQLDocVars,
  GraphQLFieldSimple,
  GraphQLSelectionSetNode,
  GraphQLSelections,
  Operations,
  OperationKeys,
  Results,
  CombinedError,
  Signals,
  OperationMetadata,
  ClientArchitecture,
  ClientEventHub,
  Exchanges,
  ExchangeStructure,
  ExchangeSignature,
  OperationFlow,
  TeardownFlow,
  CacheData,
  NormalisedCacheData,
  Introspection,
  DocumentCaching,
  React
};